import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.instructions');
import { HostListener, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-admin-instructions',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin.instructions/view.scss */
:host ::ng-deep .instruction-md-viewer {
  line-height: 1.65;
  overflow-wrap: anywhere;
  word-break: break-word;
}

:host ::ng-deep .instruction-md-viewer h1,
:host ::ng-deep .instruction-md-viewer h2,
:host ::ng-deep .instruction-md-viewer h3,
:host ::ng-deep .instruction-md-viewer h4,
:host ::ng-deep .instruction-md-viewer h5,
:host ::ng-deep .instruction-md-viewer h6 {
  margin: 14px 0 8px;
  color: #0f172a;
  font-weight: 700;
  letter-spacing: 0;
}

:host ::ng-deep .instruction-md-viewer h1 {
  font-size: 18px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e2e8f0;
}

:host ::ng-deep .instruction-md-viewer h2 {
  font-size: 15px;
  padding-bottom: 6px;
  border-bottom: 1px solid #f1f5f9;
}

:host ::ng-deep .instruction-md-viewer h3 {
  font-size: 13px;
}

:host ::ng-deep .instruction-md-viewer h4,
:host ::ng-deep .instruction-md-viewer h5,
:host ::ng-deep .instruction-md-viewer h6 {
  font-size: 12px;
}

:host ::ng-deep .instruction-md-viewer p {
  margin: 8px 0;
}

:host ::ng-deep .instruction-md-viewer ul,
:host ::ng-deep .instruction-md-viewer ol {
  margin: 8px 0;
  padding-left: 20px;
}

:host ::ng-deep .instruction-md-viewer li {
  margin: 3px 0;
}

:host ::ng-deep .instruction-md-viewer blockquote {
  margin: 10px 0;
  padding: 8px 12px;
  border-left: 3px solid #94a3b8;
  background: #f8fafc;
  color: #475569;
}

:host ::ng-deep .instruction-md-viewer pre {
  margin: 10px 0;
  padding: 12px;
  overflow: auto;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #0f172a;
  color: #e2e8f0;
  font-family: "D2Coding", "Menlo", monospace;
  font-size: 12px;
  line-height: 1.55;
  white-space: pre;
}

:host ::ng-deep .instruction-md-viewer code {
  padding: 1px 4px;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  background: #f8fafc;
  color: #334155;
  font-family: "D2Coding", "Menlo", monospace;
  font-size: 11px;
}

:host ::ng-deep .instruction-md-viewer pre code {
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font-size: inherit;
}

:host ::ng-deep .instruction-md-viewer table {
  width: 100%;
  margin: 10px 0;
  border-collapse: collapse;
  font-size: 12px;
}

:host ::ng-deep .instruction-md-viewer th,
:host ::ng-deep .instruction-md-viewer td {
  padding: 7px 8px;
  border: 1px solid #e2e8f0;
  vertical-align: top;
}

:host ::ng-deep .instruction-md-viewer th {
  background: #f8fafc;
  color: #334155;
  font-weight: 700;
  text-align: left;
}

:host ::ng-deep .instruction-md-viewer a {
  color: #2563eb;
  text-decoration: underline;
}

:host ::ng-deep .instruction-md-viewer hr {
  margin: 14px 0;
  border: 0;
  border-top: 1px solid #e2e8f0;
}

:host ::ng-deep .instruction-md-viewer .instruction-md-empty {
  color: #94a3b8;
}

:host ::ng-deep .legacy-instruction-md-viewer h1 {
  font-size: 15px;
}

:host ::ng-deep .legacy-instruction-md-viewer h2 {
  font-size: 13px;
}

:host ::ng-deep .legacy-instruction-md-viewer pre {
  background: #f5f5f5;
  color: #333333;
}

@media (max-width: 767px) {
  .admin-instructions-retro {
    height: 100%;
    min-height: 0 !important;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 8px !important;
  }
  .admin-instructions-retro-header {
    flex-wrap: wrap;
    gap: 6px;
    padding: 8px 10px !important;
  }
  .admin-instructions-retro-grid {
    grid-template-columns: minmax(0, 1fr) !important;
    gap: 8px !important;
    margin-top: 8px !important;
  }
  .admin-instructions-retro-sidebar,
  .admin-instructions-retro-main {
    min-width: 0;
  }
  .admin-instructions-retro div[style*="display: grid"] {
    grid-template-columns: minmax(0, 1fr) !important;
  }
  .admin-instructions-retro div[style*="justify-content: space-between"] {
    flex-wrap: wrap;
  }
  .admin-instructions-retro input,
  .admin-instructions-retro select,
  .admin-instructions-retro textarea,
  .admin-instructions-retro button {
    max-width: 100%;
  }
  .admin-instructions-retro table {
    width: 100% !important;
    min-width: 0;
    table-layout: auto;
  }
  .admin-instructions-retro th,
  .admin-instructions-retro td {
    overflow-wrap: anywhere;
    word-break: break-word;
  }
  .admin-instructions-retro .legacy-instruction-md-viewer {
    max-height: 46vh !important;
  }
}`],
})
export class PageAdminInstructionsComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public theme: string = 'modern';
    public instructionSources: any[] = [];
    public existingInstructions: any[] = [];
    public existingInstructionLoading: boolean = false;
    public selectedExistingInstruction: any = null;
    public selectedExistingInstructionKey: string = '';
    public selectedExistingInstructionCategoryKey: string = '';
    public existingInstructionContent: string = '';
    public existingInstructionEditContent: string = '';
    public existingInstructionViewerHtml: string = '';
    public existingInstructionEditing: boolean = false;
    public sourcePanelOpen: boolean = true;
    public instructionLoading: boolean = false;
    public instructionUploading: boolean = false;
    public instructionGenerating: boolean = false;
    public instructionResearching: boolean = false;
    public instructionSaving: boolean = false;
    public instructionError: string = '';
    public selectedInstructionSourceId: string = '';
    public instructionUploadFile: File | null = null;
    public instructionUploadFiles: File[] = [];
    public instructionUploadFileDescriptions: any[] = [];
    public instructionUploadName: string = '';
    public instructionPreviewText: string = '';
    public instructionResearchQuery: string = '';
    public instructionResearchText: string = '';
    public instructionResearchModalOpen: boolean = false;
    public instructionResearchModalTitle: string = '기준자료 조사';
    public instructionForm: any = {
        title: '',
        source_kind: 'instruction_document',
        target_intent: 'general',
        custom_target: '',
        description: '',
        source_text: '',
    };
    public instructionDraft: any = {
        name: '',
        content: '',
        method: '',
        source_chars: 0,
    };
    public instructionTargets: any[] = [
        { id: 'general', label: '일반' },
        { id: 'omission_check', label: '누락 검사' },
        { id: 'copy_check', label: '카피 검사' },
        { id: 'typo_check', label: '오탈자 검사' },
        { id: 'context_check', label: '문맥 검사' },
        { id: 'consistency_check', label: '일치성 검사' },
        { id: 'state_evaluation_check', label: '상태평가 적정성 검사' },
        { id: 'custom', label: '기타' },
    ];
    public instructionSourceKinds: any[] = [
        { id: 'instruction_document', label: '지침내용' },
        { id: 'rfp', label: '제안요청서' },
        { id: 'evaluation_guideline', label: '평가 가이드라인' },
        { id: 'metric', label: '평가 지표' },
        { id: 'law', label: '법령/고시' },
        { id: 'manual', label: '점검 매뉴얼' },
        { id: 'template', label: '검사 서식' },
        { id: 'reference', label: '참조 자료' },
    ];
    public instructionFileRoles: any[] = [
        { id: 'instruction_document', label: '지침내용' },
        { id: 'rfp', label: '제안요청서' },
        { id: 'evaluation_guideline', label: '평가 가이드라인' },
        { id: 'contract', label: '계약/과업 기준' },
        { id: 'reference', label: '참고자료' },
        { id: 'other', label: '기타' },
    ];

    public async ngOnInit() {
        await this.service.init();
        this.syncTheme();
        await this.refreshAll();
        await this.service.render();
    }

    @HostListener('window:storage', ['$event'])
    public onStorageChange(event: StorageEvent) {
        if (event.key !== 'ui-theme') return;
        this.syncTheme(event.newValue);
        this.service.render();
    }

    private normalizeTheme(value: any): string {
        return value === 'retro' ? 'retro' : 'modern';
    }

    private syncTheme(value: any = localStorage.getItem('ui-theme')) {
        this.theme = this.normalizeTheme(value);
    }

    private getErrorMessage(error: any, fallback: string): string {
        if (!error) return fallback;
        if (typeof error === 'string') return error;
        if (error?.data?.message) return error.data.message;
        if (error?.responseJSON?.data?.message) return error.responseJSON.data.message;
        if (error?.responseJSON?.message) return error.responseJSON.message;
        if (error?.message) return error.message;
        try {
            const text = JSON.stringify(error);
            return text && text !== '{}' ? text : fallback;
        } catch (e) {
            return fallback;
        }
    }

    public targetLabel(id: string, customTarget: string = ''): string {
        if (id === 'custom') return customTarget || '기타';
        return this.instructionTargets.find((item: any) => item.id === id)?.label || id || '-';
    }

    public sourceKindLabel(id: string): string {
        return this.instructionSourceKinds.find((item: any) => item.id === id)?.label || id || '-';
    }

    public fileRoleLabel(id: string): string {
        return this.instructionFileRoles.find((item: any) => item.id === id)?.label || id || '참고자료';
    }

    private defaultFileRoleForSourceKind(sourceKind: string = this.instructionForm.source_kind): string {
        if (['instruction_document', 'rfp', 'evaluation_guideline'].includes(sourceKind)) return sourceKind;
        return 'reference';
    }

    private inferInstructionFileRole(name: string): string {
        const text = String(name || '').toLowerCase();
        if (text.includes('제안요청') || text.includes('rfp')) return 'rfp';
        if (text.includes('평가') && (text.includes('가이드') || text.includes('guideline') || text.includes('기준'))) return 'evaluation_guideline';
        if (text.includes('지침') || text.includes('instruction') || text.includes('manual')) return 'instruction_document';
        if (text.includes('계약') || text.includes('과업')) return 'contract';
        return this.defaultFileRoleForSourceKind();
    }

    private normalizeInstructionSource(source: any): any {
        const normalized = { ...(source || {}) };
        normalized.files = (normalized.files || []).map((file: any) => ({
            ...file,
            role: file.role || this.defaultFileRoleForSourceKind(normalized.source_kind || 'reference'),
        }));
        return normalized;
    }

    public get selectedInstructionSource(): any {
        return this.instructionSources.find((item: any) => item.id === this.selectedInstructionSourceId) || null;
    }

    public formatSize(bytes: number): string {
        if (!bytes) return '0 B';
        if (bytes < 1024) return bytes + ' B';
        if (bytes < 1048576) return (bytes / 1024).toFixed(1) + ' KB';
        return (bytes / 1048576).toFixed(1) + ' MB';
    }

    public instructionKindLabel(kind: string): string {
        if (kind === 'managed') return '기본';
        if (kind === 'skill') return '생성';
        return kind || '-';
    }

    public instructionCategoryLabel(key: string): string {
        const labels: any = {
            common: '공통/계획',
            inspection_omission: '누락 검사',
            inspection_copy: '카피 검사',
            inspection_typo: '오탈자 검사',
            inspection_context: '문맥 검사',
            inspection_consistency: '일치성 검사',
            inspection_state_evaluation: '상태평가 검사',
            inspection_proposal: '제안서 평가',
            inspection: '검사 기타',
            managed: '기본 지시사항',
            chat: '일반 대화',
            routing: '라우팅',
            preprocessing: '전처리',
            analysis: '분석/요약',
            memory: '메모리',
            info: '안내',
            skill: '생성 지시사항',
            uncategorized: '기타',
        };
        return labels[key] || key || '기타';
    }

    public existingInstructionCategoryKey(item: any): string {
        const name = String(item?.name || '').replace(/\.md$/i, '').toLowerCase();
        const title = String(item?.title || '').toLowerCase();
        const category = String(item?.category || '').trim();
        const text = `${name} ${title}`;

        if (name === 'common' || name === 'planning') return 'common';
        if (text.includes('omission') || text.includes('누락')) return 'inspection_omission';
        if (text.includes('copy') || text.includes('카피')) return 'inspection_copy';
        if (text.includes('typo') || text.includes('오탈자')) return 'inspection_typo';
        if (text.includes('state_evaluation') || text.includes('상태평가')) return 'inspection_state_evaluation';
        if (text.includes('proposal') || text.includes('제안서')) return 'inspection_proposal';
        if (text.includes('consistency') || text.includes('일치성')) return 'inspection_consistency';
        if (text.includes('context') || text.includes('문맥')) return 'inspection_context';
        if (name === 'general' || category === 'chat') return 'chat';
        if (name === 'intent' || category === 'routing') return 'routing';
        if (name === 'parse' || category === 'preprocessing') return 'preprocessing';
        if (name === 'summarize' || category === 'analysis') return 'analysis';
        if (name === 'memory' || category === 'memory') return 'memory';
        if (name === 'introduce' || category === 'info') return 'info';
        if (category === 'inspection') return 'inspection';
        if (category) return category;
        if (item?.kind === 'managed') return 'managed';
        if (item?.kind === 'skill') return 'skill';
        return 'uncategorized';
    }

    public get existingInstructionGroups(): any[] {
        const order = [
            'common',
            'inspection_omission',
            'inspection_copy',
            'inspection_typo',
            'inspection_context',
            'inspection_consistency',
            'inspection_state_evaluation',
            'inspection_proposal',
            'inspection',
            'chat',
            'routing',
            'preprocessing',
            'analysis',
            'memory',
            'info',
            'managed',
            'skill',
            'uncategorized',
        ];
        const groups: any = {};
        for (const item of this.existingInstructions || []) {
            const key = this.existingInstructionCategoryKey(item);
            if (!groups[key]) {
                groups[key] = {
                    key,
                    label: this.instructionCategoryLabel(key),
                    items: [],
                };
            }
            groups[key].items.push(item);
        }

        return Object.keys(groups)
            .map((key: string) => groups[key])
            .sort((a: any, b: any) => {
                const ai = order.indexOf(a.key);
                const bi = order.indexOf(b.key);
                if (ai !== -1 || bi !== -1) return (ai === -1 ? 999 : ai) - (bi === -1 ? 999 : bi);
                return a.label.localeCompare(b.label);
            });
    }

    public get filteredExistingInstructions(): any[] {
        if (!this.selectedExistingInstructionCategoryKey) return this.existingInstructions || [];
        return (this.existingInstructions || []).filter((item: any) => this.existingInstructionCategoryKey(item) === this.selectedExistingInstructionCategoryKey);
    }

    private syncExistingInstructionCategory(preferredInstruction: any = null) {
        const groups = this.existingInstructionGroups;
        if (groups.length === 0) {
            this.selectedExistingInstructionCategoryKey = '';
            return;
        }

        const instruction = preferredInstruction || this.selectedExistingInstruction;
        const preferredKey = instruction ? this.existingInstructionCategoryKey(instruction) : '';
        const hasPreferred = preferredKey && groups.some((group: any) => group.key === preferredKey);
        if (hasPreferred) {
            this.selectedExistingInstructionCategoryKey = preferredKey;
            return;
        }

        const hasSelected = groups.some((group: any) => group.key === this.selectedExistingInstructionCategoryKey);
        if (!hasSelected) {
            this.selectedExistingInstructionCategoryKey = groups[0].key;
        }
    }

    public async selectExistingInstructionCategory(group: any) {
        if (!group) return;
        this.selectedExistingInstructionCategoryKey = group.key;
        const currentKey = this.selectedExistingInstruction ? this.existingInstructionCategoryKey(this.selectedExistingInstruction) : '';
        if (currentKey === group.key) {
            await this.service.render();
            return;
        }

        const first = group.items?.[0];
        if (first) {
            await this.openExistingInstruction(first);
            return;
        }

        this.closeExistingInstruction();
    }

    public async openExistingInstructionCategoryByKey() {
        const group = this.existingInstructionGroups.find((item: any) => item.key === this.selectedExistingInstructionCategoryKey);
        if (group) {
            await this.selectExistingInstructionCategory(group);
        }
    }

    private escapeHtml(value: any): string {
        return String(value || '')
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }

    private renderInlineMarkdown(value: string): string {
        let html = this.escapeHtml(value);
        html = html.replace(/`([^`]+)`/g, '<code>$1</code>');
        html = html.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
        html = html.replace(/__([^_]+)__/g, '<strong>$1</strong>');
        html = html.replace(/(^|[^*])\*([^*\n]+)\*/g, '$1<em>$2</em>');
        html = html.replace(/\[([^\]]+)\]\((https?:\/\/[^)\s]+)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>');
        return html;
    }

    private renderMarkdownTable(lines: string[]): string {
        const rows = lines.map((line: string) => line.trim().replace(/^\|/, '').replace(/\|$/, '').split('|').map((cell: string) => cell.trim()));
        if (rows.length < 2) return '';
        const head = rows[0] || [];
        const body = rows.slice(2);
        const headHtml = head.map((cell: string) => `<th>${this.renderInlineMarkdown(cell)}</th>`).join('');
        const bodyHtml = body.map((row: string[]) => `<tr>${row.map((cell: string) => `<td>${this.renderInlineMarkdown(cell)}</td>`).join('')}</tr>`).join('');
        return `<table><thead><tr>${headHtml}</tr></thead><tbody>${bodyHtml}</tbody></table>`;
    }

    private flushMarkdownParagraph(buffer: string[], out: string[]) {
        if (buffer.length === 0) return;
        out.push(`<p>${this.renderInlineMarkdown(buffer.join(' '))}</p>`);
        buffer.length = 0;
    }

    public renderInstructionMarkdown(content: string): string {
        const text = String(content || '').replace(/\r\n/g, '\n').replace(/\r/g, '\n');
        if (!text.trim()) return '<p class="instruction-md-empty">내용이 없습니다.</p>';

        const lines = text.split('\n');
        const out: string[] = [];
        const paragraph: string[] = [];
        let inCode = false;
        let codeLang = '';
        let codeLines: string[] = [];

        for (let i = 0; i < lines.length; i++) {
            const line = lines[i];
            const trimmed = line.trim();

            if (trimmed.startsWith('```')) {
                if (inCode) {
                    out.push(`<pre><code data-lang="${this.escapeHtml(codeLang)}">${this.escapeHtml(codeLines.join('\n'))}</code></pre>`);
                    inCode = false;
                    codeLang = '';
                    codeLines = [];
                } else {
                    this.flushMarkdownParagraph(paragraph, out);
                    inCode = true;
                    codeLang = trimmed.slice(3).trim();
                }
                continue;
            }

            if (inCode) {
                codeLines.push(line);
                continue;
            }

            if (!trimmed) {
                this.flushMarkdownParagraph(paragraph, out);
                continue;
            }

            if (/^\|.+\|$/.test(trimmed) && i + 1 < lines.length && /^\|?\s*:?-{3,}:?\s*(\|\s*:?-{3,}:?\s*)+\|?$/.test(lines[i + 1].trim())) {
                this.flushMarkdownParagraph(paragraph, out);
                const tableLines = [line, lines[i + 1]];
                i += 2;
                while (i < lines.length && /^\|.+\|$/.test(lines[i].trim())) {
                    tableLines.push(lines[i]);
                    i++;
                }
                i--;
                out.push(this.renderMarkdownTable(tableLines));
                continue;
            }

            const heading = trimmed.match(/^(#{1,6})\s+(.+)$/);
            if (heading) {
                this.flushMarkdownParagraph(paragraph, out);
                const level = Math.min(heading[1].length, 6);
                out.push(`<h${level}>${this.renderInlineMarkdown(heading[2])}</h${level}>`);
                continue;
            }

            if (/^---+$/.test(trimmed)) {
                this.flushMarkdownParagraph(paragraph, out);
                out.push('<hr>');
                continue;
            }

            const quote = trimmed.match(/^>\s?(.*)$/);
            if (quote) {
                this.flushMarkdownParagraph(paragraph, out);
                out.push(`<blockquote>${this.renderInlineMarkdown(quote[1])}</blockquote>`);
                continue;
            }

            const unordered = trimmed.match(/^[-*]\s+(.+)$/);
            if (unordered) {
                this.flushMarkdownParagraph(paragraph, out);
                const items = [unordered[1]];
                while (i + 1 < lines.length) {
                    const next = lines[i + 1].trim().match(/^[-*]\s+(.+)$/);
                    if (!next) break;
                    items.push(next[1]);
                    i++;
                }
                out.push(`<ul>${items.map((item: string) => `<li>${this.renderInlineMarkdown(item)}</li>`).join('')}</ul>`);
                continue;
            }

            const ordered = trimmed.match(/^\d+\.\s+(.+)$/);
            if (ordered) {
                this.flushMarkdownParagraph(paragraph, out);
                const items = [ordered[1]];
                while (i + 1 < lines.length) {
                    const next = lines[i + 1].trim().match(/^\d+\.\s+(.+)$/);
                    if (!next) break;
                    items.push(next[1]);
                    i++;
                }
                out.push(`<ol>${items.map((item: string) => `<li>${this.renderInlineMarkdown(item)}</li>`).join('')}</ol>`);
                continue;
            }

            paragraph.push(trimmed);
        }

        if (inCode) {
            out.push(`<pre><code data-lang="${this.escapeHtml(codeLang)}">${this.escapeHtml(codeLines.join('\n'))}</code></pre>`);
        }
        this.flushMarkdownParagraph(paragraph, out);
        return out.join('');
    }

    private updateExistingInstructionViewer() {
        this.existingInstructionViewerHtml = this.renderInstructionMarkdown(this.existingInstructionContent);
    }

    public existingInstructionKey(item: any): string {
        return item ? `${item.kind}::${item.name}` : '';
    }

    private defaultInstructionName(source: any): string {
        const suffix = String(source?.id || Date.now()).slice(-8).replace(/[^a-zA-Z0-9]/g, '');
        const customIntent = source?.target_intent === 'custom' ? (source?.custom_target || 'custom') : '';
        const intent = String(customIntent || source?.target_intent || this.instructionForm.target_intent || 'general').replace(/[^a-zA-Z0-9_]/g, '_');
        return `facility_${intent}_${suffix || 'custom'}`;
    }

    public async loadInstructionSources() {
        this.instructionLoading = true;
        this.instructionError = '';
        await this.service.render();
        try {
            const res: any = await wiz.call('instruction_source_list');
            if (res.code === 200) {
                this.instructionSources = (res.data?.sources || []).map((source: any) => this.normalizeInstructionSource(source));
                if (!this.selectedInstructionSourceId && this.instructionSources.length > 0) {
                    this.selectInstructionSource(this.instructionSources[0]);
                }
                if (this.instructionSources.length === 0) {
                    this.sourcePanelOpen = true;
                } else if (!this.instructionForm.title && !this.instructionForm.source_text && this.instructionUploadFiles.length === 0) {
                    this.sourcePanelOpen = false;
                }
            } else {
                this.instructionError = res.data?.message || '기준자료 목록을 불러오지 못했습니다.';
            }
        } catch (e) {
            this.instructionError = this.getErrorMessage(e, '기준자료 목록을 불러오지 못했습니다.');
        }
        this.instructionLoading = false;
        await this.service.render();
    }

    public async loadExistingInstructions() {
        this.existingInstructionLoading = true;
        this.instructionError = '';
        await this.service.render();
        let defaultInstruction: any = null;
        try {
            const res: any = await wiz.call('instruction_existing_list');
            if (res.code === 200) {
                this.existingInstructions = res.data?.instructions || [];
                if (!this.selectedExistingInstruction && this.existingInstructions.length > 0) {
                    defaultInstruction = this.existingInstructions.find((item: any) => item.kind === 'managed' && item.name === 'common.md')
                        || this.existingInstructions[0];
                }
                this.syncExistingInstructionCategory(defaultInstruction || this.selectedExistingInstruction);
            } else {
                this.instructionError = res.data?.message || '현재 지시사항 목록을 불러오지 못했습니다.';
            }
        } catch (e) {
            this.instructionError = this.getErrorMessage(e, '현재 지시사항 목록을 불러오지 못했습니다.');
        }
        this.existingInstructionLoading = false;
        await this.service.render();
        if (defaultInstruction) {
            await this.openExistingInstruction(defaultInstruction);
        }
    }

    public async refreshAll() {
        await this.loadInstructionSources();
        await this.loadExistingInstructions();
    }

    public toggleSourcePanel() {
        this.sourcePanelOpen = !this.sourcePanelOpen;
        this.service.render();
    }

    public async openExistingInstruction(item: any) {
        if (!item) return;
        if (this.existingInstructionEditing && this.existingInstructionEditContent !== this.existingInstructionContent) {
            const ok = await this.service.alert.show({
                title: '편집 중',
                message: '저장하지 않은 변경사항이 있습니다. 다른 지시사항을 열까요?',
                action: '열기',
                cancel: '취소',
            });
            if (!ok) {
                this.selectedExistingInstructionKey = this.existingInstructionKey(this.selectedExistingInstruction);
                this.syncExistingInstructionCategory(this.selectedExistingInstruction);
                await this.service.render();
                return;
            }
        }
        this.existingInstructionLoading = true;
        this.instructionError = '';
        await this.service.render();
        try {
            const res: any = await wiz.call('instruction_existing_read', {
                kind: item.kind,
                name: item.name,
            });
            if (res.code === 200) {
                this.selectedExistingInstruction = res.data?.instruction || item;
                this.selectedExistingInstructionKey = this.existingInstructionKey(this.selectedExistingInstruction);
                this.syncExistingInstructionCategory(this.selectedExistingInstruction);
                this.existingInstructionContent = res.data?.content || '';
                this.existingInstructionEditContent = '';
                this.existingInstructionEditing = false;
                this.updateExistingInstructionViewer();
            } else {
                this.instructionError = res.data?.message || '지시사항을 불러오지 못했습니다.';
            }
        } catch (e) {
            this.instructionError = this.getErrorMessage(e, '지시사항을 불러오지 못했습니다.');
        }
        this.existingInstructionLoading = false;
        await this.service.render();
    }

    public async openExistingInstructionByKey() {
        const item = this.existingInstructions.find((instruction: any) => this.existingInstructionKey(instruction) === this.selectedExistingInstructionKey);
        if (item) {
            await this.openExistingInstruction(item);
        }
    }

    public closeExistingInstruction() {
        this.selectedExistingInstruction = null;
        this.selectedExistingInstructionKey = '';
        this.syncExistingInstructionCategory(null);
        this.existingInstructionContent = '';
        this.existingInstructionEditContent = '';
        this.existingInstructionViewerHtml = '';
        this.existingInstructionEditing = false;
        this.service.render();
    }

    public useExistingInstructionAsDraft() {
        const content = this.existingInstructionEditing ? this.existingInstructionEditContent : this.existingInstructionContent;
        if (!content || !this.selectedExistingInstruction) return;
        const name = String(this.selectedExistingInstruction.name || '').replace(/\.md$/, '');
        this.instructionDraft = {
            name: name || this.instructionDraft.name,
            content,
            method: this.instructionKindLabel(this.selectedExistingInstruction.kind),
            source_chars: content.length,
        };
        this.service.render();
    }

    public startExistingInstructionEdit() {
        if (!this.selectedExistingInstruction) return;
        this.existingInstructionEditContent = this.existingInstructionContent;
        this.existingInstructionEditing = true;
        this.service.render();
    }

    public cancelExistingInstructionEdit() {
        this.existingInstructionEditContent = '';
        this.existingInstructionEditing = false;
        this.service.render();
    }

    public async saveExistingInstructionEdit() {
        if (!this.selectedExistingInstruction) return;
        const content = String(this.existingInstructionEditContent || '');
        if (!content.trim()) {
            await this.service.alert.show({
                title: '내용 필요',
                message: '저장할 지시사항 내용을 입력해주세요.',
                action: '확인',
            });
            return;
        }

        this.instructionSaving = true;
        this.instructionError = '';
        await this.service.render();
        try {
            const res: any = await wiz.call('instruction_existing_update', {
                kind: this.selectedExistingInstruction.kind,
                name: this.selectedExistingInstruction.name,
                content,
            });
            if (res.code === 200) {
                this.selectedExistingInstruction = res.data?.instruction || this.selectedExistingInstruction;
                this.selectedExistingInstructionKey = this.existingInstructionKey(this.selectedExistingInstruction);
                this.existingInstructionContent = res.data?.content || content;
                this.existingInstructionEditContent = '';
                this.existingInstructionEditing = false;
                this.updateExistingInstructionViewer();
                await this.loadExistingInstructions();
            } else {
                this.instructionError = res.data?.message || '지시사항을 저장하지 못했습니다.';
            }
        } catch (e) {
            this.instructionError = this.getErrorMessage(e, '지시사항을 저장하지 못했습니다.');
        }
        this.instructionSaving = false;
        await this.service.render();
    }

    public onInstructionFileChange(event: Event) {
        const input = event.target as HTMLInputElement;
        const files = input.files ? Array.from(input.files) : [];
        const file = files.length > 0 ? files[0] : null;
        const previousDescriptions = new Map<string, any>(
            this.instructionUploadFileDescriptions.map((item: any) => [item.name, {
                description: item.description || '',
                role: item.role || '',
            }])
        );
        this.instructionUploadFiles = files;
        this.instructionUploadFile = file;
        this.instructionUploadName = files.length > 1 ? `${files.length}개 파일` : (file ? file.name : '');
        this.instructionUploadFileDescriptions = files.map((selectedFile: any) => {
            const name = selectedFile.webkitRelativePath || selectedFile.name || '';
            const previous = previousDescriptions.get(name) || {};
            return {
                name,
                filename: selectedFile.name || name,
                size: selectedFile.size || 0,
                role: previous.role || this.inferInstructionFileRole(name),
                description: previous.description || '',
            };
        });
        if (file && !this.instructionForm.title) {
            this.instructionForm.title = file.name.replace(/\.[^.]+$/, '');
        }
        this.service.render();
    }

    public async uploadInstructionSource() {
        const directText = String(this.instructionForm.source_text || '').trim();
        if (this.instructionUploadFiles.length === 0 && !directText) {
            await this.service.alert.show({
                title: '기준 필요',
                message: '파일을 선택하거나 지시사항/쿼리를 직접 입력해주세요.',
                action: '확인',
            });
            return;
        }

        this.instructionUploading = true;
        this.instructionError = '';
        await this.service.render();

        const fd = new FormData();
        for (const file of this.instructionUploadFiles) {
            fd.append('file[]', file, (file as any).webkitRelativePath || file.name);
        }
        fd.append('title', this.instructionForm.title || this.instructionUploadFile?.name || directText.slice(0, 30) || '직접 입력 기준');
        fd.append('source_kind', this.instructionForm.source_kind || 'reference');
        fd.append('target_intent', this.instructionForm.target_intent || 'general');
        fd.append('custom_target', this.instructionForm.custom_target || '');
        fd.append('description', this.instructionForm.description || '');
        fd.append('file_descriptions', JSON.stringify(this.instructionUploadFileDescriptions || []));
        fd.append('source_text', directText);

        let shouldResearchAfterUpload = false;
        try {
            const res: any = await wiz.call('instruction_source_upload', fd, {
                contentType: false,
                processData: false,
            });
            if (res.code === 200) {
                this.instructionUploadFile = null;
                this.instructionUploadFiles = [];
                this.instructionUploadFileDescriptions = [];
                this.instructionUploadName = '';
                this.sourcePanelOpen = false;
                this.instructionForm.title = '';
                this.instructionForm.description = '';
                this.instructionForm.source_text = '';
                await this.loadInstructionSources();
                if (res.data?.source) {
                    this.selectInstructionSource(res.data.source);
                    shouldResearchAfterUpload = true;
                }
            } else {
                this.instructionError = res.data?.message || '등록에 실패했습니다.';
            }
        } catch (e) {
            this.instructionError = this.getErrorMessage(e, '등록에 실패했습니다.');
        }

        this.instructionUploading = false;
        await this.service.render();

        if (shouldResearchAfterUpload) {
            await this.researchInstructionSource();
        }
    }

    public selectInstructionSource(source: any) {
        if (!source) return;
        this.selectedInstructionSourceId = source.id;
        this.instructionPreviewText = '';
        this.instructionResearchText = '';
        this.instructionResearchModalOpen = false;
        this.instructionForm.source_kind = source.source_kind || this.instructionForm.source_kind || 'reference';
        this.instructionForm.target_intent = source.target_intent || this.instructionForm.target_intent || 'general';
        this.instructionForm.custom_target = source.custom_target || this.instructionForm.custom_target || '';
        if (!this.instructionDraft.name || this.instructionDraft.name.indexOf('facility_') === 0) {
            this.instructionDraft.name = source.generated_skill || this.defaultInstructionName(source);
        }
        this.service.render();
    }

    public async updateInstructionSource() {
        const source = this.selectedInstructionSource;
        if (!source) return;
        this.instructionSaving = true;
        this.instructionError = '';
        await this.service.render();
        try {
            const res: any = await wiz.call('instruction_source_update', {
                source_id: source.id,
                title: source.title || '',
                source_kind: source.source_kind || 'reference',
                target_intent: source.target_intent || 'general',
                custom_target: source.custom_target || '',
                description: source.description || '',
                files: JSON.stringify(source.files || []),
                source_text: source.source_text || '',
            });
            if (res.code === 200) {
                await this.loadInstructionSources();
            } else {
                this.instructionError = res.data?.message || '기준자료 정보를 저장하지 못했습니다.';
            }
        } catch (e) {
            this.instructionError = this.getErrorMessage(e, '기준자료 정보를 저장하지 못했습니다.');
        }
        this.instructionSaving = false;
        await this.service.render();
    }

    public async previewInstructionSource() {
        const source = this.selectedInstructionSource;
        if (!source) return;
        this.instructionLoading = true;
        this.instructionError = '';
        await this.service.render();
        try {
            const res: any = await wiz.call('instruction_source_read', { source_id: source.id });
            if (res.code === 200) {
                this.instructionPreviewText = res.data?.text || '추출된 텍스트가 없습니다.';
            } else {
                this.instructionError = res.data?.message || '미리보기를 불러오지 못했습니다.';
            }
        } catch (e) {
            this.instructionError = this.getErrorMessage(e, '미리보기를 불러오지 못했습니다.');
        }
        this.instructionLoading = false;
        await this.service.render();
    }

    public async researchInstructionSource() {
        const source = this.selectedInstructionSource;
        if (!source) {
            await this.service.alert.show({
                title: '기준자료 선택',
                message: '먼저 조사할 기준자료를 선택해주세요.',
                action: '확인',
            });
            return;
        }
        this.instructionResearching = true;
        this.instructionError = '';
        await this.service.render();
        try {
            const res: any = await wiz.call('instruction_research', {
                source_id: source.id,
                query: this.instructionResearchQuery || '',
            });
            if (res.code === 200) {
                this.instructionResearchText = res.data?.content || '조사 결과가 없습니다.';
                this.instructionResearchModalTitle = `${source.title || source.filename || '기준자료'} 조사 결과`;
                this.instructionResearchModalOpen = true;
            } else {
                this.instructionError = res.data?.message || '기준자료 조사에 실패했습니다.';
            }
        } catch (e) {
            this.instructionError = this.getErrorMessage(e, '기준자료 조사에 실패했습니다.');
        }
        this.instructionResearching = false;
        await this.service.render();
    }

    private applyInstructionResearchToSource(): boolean {
        const source = this.selectedInstructionSource;
        const researchText = String(this.instructionResearchText || '').trim();
        if (!source || !researchText) return false;
        const current = String(source.source_text || '').trim();
        source.source_text = current ? `${current}\n\n${researchText}` : researchText;
        return true;
    }

    public appendInstructionResearchToSource() {
        if (!this.applyInstructionResearchToSource()) return;
        this.service.render();
    }

    public closeInstructionResearchModal() {
        this.instructionResearchModalOpen = false;
        this.service.render();
    }

    public rejectInstructionResearch() {
        this.instructionResearchModalOpen = false;
        this.instructionResearchText = '';
        this.service.render();
    }

    public async approveInstructionResearch() {
        if (!this.applyInstructionResearchToSource()) {
            this.closeInstructionResearchModal();
            return;
        }
        this.instructionResearchModalOpen = false;
        await this.updateInstructionSource();
    }

    public async generateInstructionDraft() {
        const source = this.selectedInstructionSource;
        if (!source) {
            await this.service.alert.show({
                title: '기준자료 선택',
                message: '먼저 지시사항으로 변환할 기준자료를 선택해주세요.',
                action: '확인',
            });
            return;
        }
        this.instructionGenerating = true;
        this.instructionError = '';
        await this.service.render();
        try {
            const res: any = await wiz.call('instruction_generate', {
                source_id: source.id,
                target_intent: source.target_intent || this.instructionForm.target_intent,
                custom_target: source.custom_target || this.instructionForm.custom_target || '',
                skill_name: this.instructionDraft.name || source.generated_skill || this.defaultInstructionName(source),
            });
            if (res.code === 200) {
                this.instructionDraft = {
                    name: res.data?.name || this.defaultInstructionName(source),
                    content: res.data?.content || '',
                    method: res.data?.method || '',
                    source_chars: res.data?.source_chars || 0,
                };
            } else {
                this.instructionError = res.data?.message || '지시사항 초안 생성에 실패했습니다.';
            }
        } catch (e) {
            this.instructionError = this.getErrorMessage(e, '지시사항 초안 생성에 실패했습니다.');
        }
        this.instructionGenerating = false;
        await this.service.render();
    }

    public async saveGeneratedInstruction() {
        const source = this.selectedInstructionSource;
        if (!this.instructionDraft.content || !this.instructionDraft.name) {
            await this.service.alert.show({
                title: '초안 필요',
                message: '저장할 지시사항 이름과 내용을 입력해주세요.',
                action: '확인',
            });
            return;
        }
        this.instructionSaving = true;
        this.instructionError = '';
        await this.service.render();
        try {
            const res: any = await wiz.call('instruction_save_generated', {
                source_id: source?.id || '',
                name: this.instructionDraft.name,
                content: this.instructionDraft.content,
            });
            if (res.code === 200) {
                await this.loadInstructionSources();
                await this.loadExistingInstructions();
                await this.service.alert.show({
                    title: '저장 완료',
                    message: `${this.instructionDraft.name}.md 지시사항을 저장했습니다.`,
                    action: '확인',
                });
            } else {
                this.instructionError = res.data?.message || '지시사항 저장에 실패했습니다.';
            }
        } catch (e) {
            this.instructionError = this.getErrorMessage(e, '지시사항 저장에 실패했습니다.');
        }
        this.instructionSaving = false;
        await this.service.render();
    }

    public async deleteInstructionSource(source: any, event?: Event) {
        if (event) event.stopPropagation();
        const ok = await this.service.alert.show({
            title: '기준자료 삭제',
            message: `${source?.filename || '선택한 기준자료'} 자료를 삭제하시겠습니까? 생성된 지시사항 파일은 유지됩니다.`,
            action: '삭제',
            actionBtn: 'error',
            cancel: '취소',
        });
        if (!ok) return;
        const res: any = await wiz.call('instruction_source_delete', { source_id: source.id });
        if (res.code === 200) {
            if (this.selectedInstructionSourceId === source.id) {
                this.selectedInstructionSourceId = '';
                this.instructionDraft = { name: '', content: '', method: '', source_chars: 0 };
                this.instructionPreviewText = '';
            }
            await this.loadInstructionSources();
        }
        await this.service.render();
    }
}

export default PageAdminInstructionsComponent;